import SelectField, { SelectFieldProps } from '@sprinx/react-mui-fields/SelectField';
import SelectFieldItem from '@sprinx/react-mui-fields/SelectFieldItem';
import { createStyles, makeStyles, Typography } from '@material-ui/core';
import React from 'react';
import { useRecoilValue } from 'recoil';
import { shoppingCustomerDeliveryPlacesAllSelector } from '../../../api/shopping';

export type CustomerProfilePageUserMainContactSelectorProps = SelectFieldProps<string>;

export type CustomerProfilePageUserMainContactSelectorClassKey = 'root';

const useStyles = makeStyles(
  createStyles<CustomerProfilePageUserMainContactSelectorClassKey, {}>({
    root: {
      '& > div > div': {
        whiteSpace: 'normal',
      },
    },
  }),
);

const CustomerProfilePageUserMainContactSelector: React.FC<CustomerProfilePageUserMainContactSelectorProps> = ({
  value,
  ...rest
}) => {
  const places: Array<any> = useRecoilValue(shoppingCustomerDeliveryPlacesAllSelector) || [];
  const classes = useStyles();

  return (
    <SelectField {...rest} value={value} fullWidth className={classes.root}>
      {places.map(({ id, name, officeName, postaddresses }, index) => {
        const address =
          (postaddresses || []).find((address: Record<string, any>) => address.type === 'HQ')?.place.full || null;
        return (
          <SelectFieldItem key={index} value={id}>
            <Typography>{`${officeName || name}${address != null ? ` - ${address}` : ''}`}</Typography>
          </SelectFieldItem>
        );
      })}
    </SelectField>
  );
};

CustomerProfilePageUserMainContactSelector.displayName = 'CustomerProfilePageUserMainContactSelector';

export default CustomerProfilePageUserMainContactSelector;
